import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api/axios";

const ThemeContext = createContext(null);

function getSavedTheme() {
  try {
    const saved = localStorage.getItem("app_theme");
    if (saved) return JSON.parse(saved);
  } catch {}
  return { activeTheme: "indigo", darkMode: false };
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getSavedTheme);

  async function loadTheme() {
    try {
      const { data } = await api.get("/theme");
      setTheme(data.theme);
      localStorage.setItem("app_theme", JSON.stringify(data.theme));
    } catch {}
  }

  useEffect(() => { loadTheme(); }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme.activeTheme || "indigo");
    document.documentElement.setAttribute("data-mode", theme.darkMode ? "dark" : "light");
    localStorage.setItem("app_theme", JSON.stringify(theme));
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, loadTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
